// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Твои ключи (я их уже вставил)
const firebaseConfig = {
  apiKey: "AIzaSyCZkU2Tc2poEcoAArbz4DaGlx9SqNSZdYE",
  authDomain: "amore-archive.firebaseapp.com",
  projectId: "amore-archive",
  storageBucket: "amore-archive.firebasestorage.app",
  messagingSenderId: "424137108180",
  appId: "1:424137108180:web:4c9087f15454c62763a941"
};

// Инициализация
const app = initializeApp(firebaseConfig);

// Экспорт инструментов
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// Функции входа и выхода
export const signInWithGoogle = () => signInWithPopup(auth, provider);
export const logout = () => signOut(auth);